export function friendlyMessageForApiError(err) {
  if (!err) return "An error occurred";
  // If this is a normalized error thrown by adminApi.fetchWithAuth
  if (err.code) {
    switch (err.code) {
      case "ORG_MISSING":
        return "Your account is missing an organization claim. Please re-login or contact admin.";
      case "DB_NOT_FOUND":
        return "The requested database was not found.";
      case "DB_CLOSED":
        return "The requested database is closed.";
      case "NO_ACCESSIBLE_DATABASES":
        return "You don't have access to any of the requested databases.";
      default:
        return err.message || "An error occurred";
    }
  }
  // Fallback to message
  return err.message || String(err);
}
